import { render, staticRenderFns } from "./o-bottom-navigation.vue?vue&type=template&id=2bae2a82&scoped=true&"
import script from "./o-bottom-navigation.vue?vue&type=script&lang=js&"
export * from "./o-bottom-navigation.vue?vue&type=script&lang=js&"
import style0 from "./o-bottom-navigation.vue?vue&type=style&index=0&id=2bae2a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bae2a82",
  null
  
)

export default component.exports